module.exports = __webpack_public_path__ + "img/RectangleYellow.8a25b039.svg";